import React, { useState } from "react";
import AscSortIcon from "../AscSortIcon/AscSortIcon";
import DescSortIcon from "../DescSortIcon/DescSortIcon";
import "./SortCommand.css";

export default function SortCommand(props) {
  const [onClick, setOnClick] = useState(undefined);

  return (
    <div
      className="sortCommand"
      //onMouseOver={() => setOnClick(onClick ? !onClick : true)}
      onMouseEnter={() => setOnClick(onClick ? !onClick : true)}
    >
      <div><AscSortIcon /></div>
      <div style={{ marginTop:"-5px" }}><DescSortIcon /></div>
      
    </div>
  );
}
